import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Button,
  IconButton,
  TextField,
  Divider,
  Autocomplete,
} from "@mui/material";
import { getData, postData } from "../../../ServerRequest";
import FeaturedProduct from "./FeaturedProduct";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GridViewIcon from "@mui/icons-material/GridView";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
//import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
//import AddIcon from '@mui/icons-material/Add';
//import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

const buttonStyle = {
  background: "#f8f9fa",
  border: "3px solid #b0bec5",
  color: "black",
  fontSize: "0.850rem",
  "&:hover": { background: "#eceff1" },
  fontFamily: "Inter, sans-serif",
};

const sectionStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.6)",
  marginBottom: 2,
  borderRadius: 0,
  boxShadow: "0px 4px 8px rgba(0, 0, 1, 0.1)",
  fontFamily: "Inter, sans-serif",
};

const inputStyle = {
  height: 35,
  borderRadius: 0,
  fontFamily: "Inter, sans-serif",
  "& .MuiInputBase-root": {
    height: 35,
    borderRadius: 0,
    backgroundColor: "white",
    fontFamily: "Inter, sans-serif",
  },
};

export default function LandingPageFeatured() {
  const [loading, setLoading] = useState(false);
  const [sectionData, setSectionData] = useState([]);
  const [formValues, setFormValues] = useState({
    image_alt_text: "",
    title: "",
    heading: "",
    cta_text: "",
    featured_image: "",
    featured_image_file: null,
    featured_section_image: "",
    link_page: "",
    collection_name: "",
    section_title: "",
    collection: "",
    collection_url: "",
    isEditable: true,
  });
  const [selectedSection, setSelectedSection] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [editingImageUrl, setEditingImageUrl] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [selectedSectionId, setSelectedSectionId] = useState(null);
  const [collectionOptions, setCollectionOptions] = useState([]);
  const [editableFields, setEditableFields] = useState({
    section_title: false,
    title: false,
    heading: false,
    cta_text: false,
  });

  const toggleEditableField = (field) => {
    setEditableFields((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  // Moved fetchSectionData outside useEffect so it can be reused
  async function fetchSectionData() {
    let sectionResData = await getData(
      "/api/theme/landing_featured_section?is_admin=true"
    );
    console.log(sectionResData);
    let section_data = sectionResData["data"]["sections"];
    if (section_data) {
      const updatedSections = section_data.map((section) => ({
        ...section,
        collection: section.collection || "",
        collection_url: section.collection_url || "",
      }));
      setSectionData(updatedSections);
    } else {
      console.error(
        "Error fetching featured section data:",
        sectionResData.message
      );
    }

    let collectionResData = await getData("/api/product/product-collection");
    console.log(collectionResData);
    let collections_data = collectionResData["data"]["live_collections"];
    if (collections_data) {
      const formattedCollections = collections_data.map((collection) => ({
        label: collection.collection || "",
        value: collection.id || "",
        collection_url: collection.collection_url || "",
      }));
      setCollectionOptions(formattedCollections);
    } else {
      console.error(
        "Error fetching collection data:",
        collectionResData.message
      );
    }

    setLoading(false);
  }

  useEffect(() => {
    fetchSectionData();
  }, []);

  const handleFeaturedSubmit = async () => {
    let sectionReqData = {
      'id': formValues.id ? formValues.id : "",
      'image_alt_text': formValues.image_alt_text ? formValues.image_alt_text : "",
      'title': formValues.title ? formValues.title : "",
      'heading': formValues.heading ? formValues.heading : "",
      'cta_text': formValues.cta_text ? formValues.cta_text : "",
      'link_page': formValues.link_page ? formValues.link_page : "",
      'collection_name': formValues.collection_name ? formValues.collection_name : "",
      'section_title': formValues.section_title ? formValues.section_title : "",
      'collection': formValues.collection ? formValues.collection : "",
      'collection_url': formValues.collection_url ? formValues.collection_url : "",
    };

    const convertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    // Only update the image if a new file is uploaded
    if (formValues.featured_image_file) {
      sectionReqData.featured_section_image = await convertToBase64(formValues.featured_image_file);
    } // else do not include featured_section_image in the request, so the backend keeps the old image

    // Remove any undefined or empty string fields
    Object.keys(sectionReqData).forEach(
      (key) =>
        (sectionReqData[key] === undefined || sectionReqData[key] === "") &&
        delete sectionReqData[key]
    );

    console.log(sectionReqData);

    try {
      let bannerResData = await postData(
        "/api/theme/landing_featured_section",
        sectionReqData
      );
      if (bannerResData["data"]["code"] === "200") {
        alert("Section saved successfully.");
        setIsFormVisible(false);
        // Fetch latest data from backend after save
        fetchSectionData();
      } else {
        alert("Error saving section. Please try again.");
      }
    } catch (error) {
      console.error("Error saving section:", error);
    }
  };

  const handleVisibilityToggle = async (id, newStatus) => {
    // Prepare request payload
    const visibilityReqData = {
      id, // Pass the banner ID
      status: newStatus ? "enabled" : "disabled", // Update the status
    };

    try {
      // Post request to update the banner status
      let visibilityResData = await postData(
        "/api/theme/landing_featured_section?is_admin = true",
        visibilityReqData
      );

      // Handle response
      if (visibilityResData["data"]["code"] === "200") {
        alert("Banner visibility updated successfully.");
        setSectionData((prevsectionData) =>
          prevsectionData.map((banner) =>
            banner.id === id
              ? { ...banner, status: visibilityReqData.status }
              : banner
          )
        );
      } else {
        alert("Error updating banner visibility. Please try again.");
      }
    } catch (error) {
      console.error("Error updating banner visibility:", error);
    }
  };

  const handleEditImage = (image) => {
    setSelectedSectionId(image.id);
    setFormValues({
      ...image,
      featured_image_file: null, // Always reset file input on edit
      featured_section_image: image.featured_image || image.featured_section_image || "",
    });
    setSelectedSection(image);
    setIsFormVisible(true);
    setIsEditing(true);
    setExpanded(true);
    setEditingImageUrl(image.featured_image || image.featured_section_image || "");
    console.log(image);
  };

  /* const handleAddNewSection = (image) => {
        setFormValues({ altText: '', title: '', heading: '', ctaText: '', ctaLinkType: '', url: '', featured_image: '' });
        setSelectedSection(image);
        setIsFormVisible(true); 
        setIsEditing(true);
        setExpanded(true);  
    }; */

  /* const handleDeleteImage = (id) => {
        setImages(images.filter((image) => image.id !== id));
    }; */

  const handleFormChange = (field, value) => {
    setFormValues((prev) => ({ ...prev, [field]: value }));
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const img = new window.Image();
      const imageUrl = URL.createObjectURL(file);
      img.src = imageUrl;
      img.onload = () => {
        if (img.width === 1440 && img.height === 300) {
          // Revoke previous object URL if it exists
          if (
            formValues.featured_section_image &&
            formValues.featured_section_image.startsWith("blob:")
          ) {
            URL.revokeObjectURL(formValues.featured_section_image);
          }
          setFormValues((prevState) => ({
            ...prevState,
            featured_section_image: imageUrl, // Store the object URL for preview
            featured_image_file: file, // Store the file object for backend
          }));
          setEditingImageUrl("");
          // Reset the file input value so the same file can be uploaded again
          event.target.value = "";
        } else {
          URL.revokeObjectURL(imageUrl); // Clean up if not valid
          alert("Image must be 1440px wide and 300px tall or smaller.");
        }
      };
      img.onerror = () => {
        alert("Failed to load image. Please try again.");
        URL.revokeObjectURL(imageUrl); // Free up memory
      };
    }
  };

  return (
    <Box>
      <Accordion sx={sectionStyle}>
        {/* Featured Section */}
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <IconButton color="" component="icon">
              <GridViewIcon />
            </IconButton>
            <Typography variant="h7">Featured</Typography>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ background: "#eceff1", padding: 4, borderRadius: 0 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: 1,
                flexWrap: "wrap",
              }}
            >
              {sectionData.length > 0 ? (
                sectionData.map((image, index) => (
                  <Box key={image.id} sx={{ textAlign: "center" }}>
                    <img
                      src={image.featured_section_image}
                      alt={`Featured ${image.id}`}
                      style={{
                        width: "100%",
                        maxWidth: "140px",
                        height: "60px",
                        marginBottom: "10px",
                        marginTop: "10px",
                        filter:
                          image.status === "enabled" ? "none" : "blur(3px)",
                        opacity: image.status === "enabled" ? 1 : 0.6,
                        transition: "filter 0.3s ease-in-out",
                      }}
                    />
                    <Typography variant="body2">
                      {image.section_title}
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <IconButton
                        sx={{ mr: 2, color: "grey" }}
                        onClick={() =>
                          handleVisibilityToggle(
                            image.id,
                            image.status !== "enabled"
                          )
                        }
                      >
                        {image.status === "enabled" ? (
                          <VisibilityOutlinedIcon />
                        ) : (
                          <VisibilityOffOutlinedIcon />
                        )}
                      </IconButton>
                      <IconButton
                        sx={{ mr: 0, color: "grey" }}
                        onClick={() => handleEditImage(image)}
                      >
                        <EditOutlinedIcon />
                      </IconButton>
                      {/*<IconButton 
                        sx={{ color: 'red' }} 
                        onClick={() => handleDeleteImage(image.id)}
                      >
                        <DeleteOutlinedIcon />
                      </IconButton>*/}
                    </Box>
                  </Box>
                ))
              ) : (
                <Typography>No cards added yet.</Typography>
              )}
            </Box>
            {/*<IconButton sx={{ ...buttonStyle, mt: 2 }} onClick={handleAddNewSection}><AddIcon /></IconButton>*/}
          </Box>

          {/* Edit Featured section */}
          <Accordion
            sx={{
              backgroundColor: "#eceff1",
              mt: 2,
              mb: 2,
              borderRadius: 0,
              boxShadow: "none",
            }}
            expanded={expanded}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              onClick={() => setExpanded(!expanded)}
            >
              <Typography variant="h7">Edit Featured Card</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: 5, pt: 0 }}>
              {isFormVisible && (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Box sx={{ width: "100%" }}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#424956",
                        fontFamily: "Inter",
                        fontWeight: 700,
                        fontSize: 14,
                        mt: 1,
                      }}
                    >
                      Section Title
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        width: "100%",
                      }}
                    >
                      <TextField
                        fullWidth
                        disabled={!editableFields.section_title}
                        variant="outlined"
                        value={formValues.section_title}
                        onChange={(e) =>
                          handleFormChange("section_title", e.target.value)
                        }
                        helperText="Max 6 characters"
                        inputProps={{ maxLength: 6 }}
                        sx={{ ...inputStyle }}
                      />
                      <IconButton
                        aria-label="edit"
                        sx={{ color: "grey" }}
                        onClick={() => toggleEditableField("section_title")}
                      >
                        <EditOutlinedIcon />
                      </IconButton>
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    {formValues.featured_section_image || isEditing ? (
                      <figure>
                        <img
                          alt="Preview"
                          src={
                            formValues.featured_section_image ||
                            (isEditing ? editingImageUrl : null)
                          }
                          style={{
                            width: "100%",
                            maxWidth: "350px",
                            height: "auto",
                            border: "1px solid #ccc",
                            marginBottom: 2,
                          }}
                        />
                        <figcaption
                          style={{
                            fontSize: 14,
                            fontFamily: "Inter",
                            fontWeight: 500,
                          }}
                        >
                          W 1440px / H 300px
                        </figcaption>
                      </figure>
                    ) : (
                      <Box
                        sx={{
                          width: "400px",
                          height: "150px",
                          border: "1px dashed grey",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" color="textSecondary">
                          Image (1440x600)
                        </Typography>
                      </Box>
                    )}
                    <IconButton component="label" sx={{ color: "black" }}>
                      <FileUploadOutlinedIcon />
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        onChange={(e) => handleImageUpload(e)}
                      />
                    </IconButton>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#424956",
                        fontFamily: "Inter",
                        fontWeight: 700,
                        fontSize: 14,
                      }}
                    >
                      Title
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        width: "100%",
                      }}
                    >
                      <TextField
                        fullWidth
                        disabled={!editableFields.title}
                        variant="outlined"
                        placeholder="Name of the tile"
                        value={formValues.title}
                        onChange={(e) =>
                          handleFormChange("title", e.target.value)
                        }
                        helperText="Max 15 characters including space"
                        inputProps={{ maxLength: 15 }}
                        sx={{ ...inputStyle }}
                      />
                      <IconButton
                        aria-label="edit"
                        sx={{ color: "grey" }}
                        onClick={() => toggleEditableField("title")}
                      >
                        <EditOutlinedIcon />
                      </IconButton>
                    </Box>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#424956",
                        fontFamily: "Inter",
                        fontWeight: 700,
                        fontSize: 14,
                        mt: 2,
                      }}
                    >
                      Heading
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        width: "100%",
                      }}
                    >
                      <TextField
                        fullWidth
                        disabled={!editableFields.heading}
                        variant="outlined"
                        placeholder="Special feature of the tile and theme"
                        value={formValues.heading}
                        onChange={(e) =>
                          handleFormChange("heading", e.target.value)
                        }
                        helperText="Max 40 characters including space"
                        inputProps={{ maxLength: 40 }}
                        sx={{ ...inputStyle }}
                      />
                      <IconButton
                        aria-label="edit"
                        sx={{ color: "grey" }}
                        onClick={() => toggleEditableField("heading")}
                      >
                        <EditOutlinedIcon />
                      </IconButton>
                    </Box>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#424956",
                        fontFamily: "Inter",
                        fontWeight: 700,
                        fontSize: 14,
                        mt: 2,
                      }}
                    >
                      CTA Text
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        width: "100%",
                      }}
                    >
                      <TextField
                        fullWidth
                        disabled={!editableFields.cta_text}
                        variant="outlined"
                        placeholder="Type your text here"
                        value={formValues.cta_text}
                        onChange={(e) =>
                          handleFormChange("cta_text", e.target.value)
                        }
                        helperText="Max 10 characters including space"
                        inputProps={{ maxLength: 10 }}
                        sx={{ ...inputStyle }}
                      />
                      <IconButton
                        aria-label="edit"
                        sx={{ color: "grey" }}
                        onClick={() => toggleEditableField("cta_text")}
                      >
                        <EditOutlinedIcon />
                      </IconButton>
                    </Box>
                  </Box>
                  <Box>
                    <Box
                      sx={{
                        display: "flex-col",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          color: "#424956",
                          fontFamily: "Inter",
                          fontWeight: 700,
                          fontSize: 14,
                          mt: 2,
                        }}
                      >
                        Link collection page
                      </Typography>
                      <Autocomplete
                        fullWidth
                        options={[
                          { 
                            label: "None", 
                            value: "none", 
                            collection_url: "",
                          },
                          ...collectionOptions,
                        ]}
                        getOptionLabel={(option) => option.label || ""}
                        value={
                          collectionOptions.find(
                            (option) => 
                              option.value === formValues.collection ||
                              option.label === formValues.collection_name
                          ) || { 
                            label: formValues.collection_name || "None", 
                            value: formValues.collection || "none",
                            collection_url: formValues.collection_url || "",
                          }
                        }
                        onChange={(event, newValue) => {
                          const updatedFormValues = { ...formValues };
                          if (newValue?.value === "none") {
                            updatedFormValues.collection = ""; // Clear the collection when "None" is selected
                            updatedFormValues.collection_url = ""; // Clear the URL
                            updatedFormValues.collection_name = ""; // Clear the collection name
                            updatedFormValues.link_page = ""; // Clear the URL
                            updatedFormValues.isEditable = true; // Enable the text field
                          } else {
                            updatedFormValues.collection = newValue?.value || "";
                            updatedFormValues.collection_url = newValue?.collection_url || ""; // Update the URL to the selected collection's collection_url
                            updatedFormValues.collection_name = newValue?.label || ""; // Set collection_name to the selected collection's label
                            updatedFormValues.link_page = newValue?.collection_url || ""; // Set link_page to the selected collection's collection_url
                            updatedFormValues.isEditable = false; // Disable the text field
                          }
                          setFormValues(updatedFormValues);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            sx={{
                              ...inputStyle,
                              mb: 2,
                            }}
                          />
                        )}
                      />
                    </Box>
                    <Divider sx={{ margin: 0 }}>OR</Divider>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#424956",
                        fontFamily: "Inter",
                        fontWeight: 700,
                        fontSize: 14,
                        mt: 1,
                      }}
                    >
                      URL link to collection page
                    </Typography>
                    <TextField
                      fullWidth
                      variant="outlined"
                      placeholder="URL"
                      disabled={!formValues.isEditable}
                      value={formValues.link_page}
                      onChange={(e) => {
                        const updatedFormValues = { ...formValues };
                        updatedFormValues.link_page = e.target.value;
                        setFormValues(updatedFormValues);
                      }}
                      sx={{
                        ...inputStyle,
                      }}
                    />
                  </Box>
                  <Box>
                    <Button
                      variant="contained"
                      onClick={() => handleFeaturedSubmit()}
                      sx={{ ...buttonStyle, mt: 2 }}
                    >
                      Save
                    </Button>
                  </Box>
                </Box>
              )}
            </AccordionDetails>
          </Accordion>
          <Divider sx={{ marginBottom: 3, marginTop: 2 }} />

          {/* Featured Product */}
          {selectedSectionId ? (
            <FeaturedProduct selectionId={selectedSectionId} />
          ) : null}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
